<template>
	<div class="tab_1">
		<el-row :gutter="5">
			<el-col :span="6" v-for="(item,i) in cardList" :key="i">
				<el-card >
					<div class="card"  @mouseover="update(item)" @mouseout="update(item)">
						<img :src="item.img" />
						<div>
							<p>{{item.name}}</p>
							<p>{{item.desc}}</p>
						</div>
					</div>
				</el-card>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		name: 'tab_1',
		data() {
			return {
				cardList: [{
						"name": "净水器",
						"desc": "实时监测水质，用水健康提醒",
						"img": require('@/assets/img/solution/cardlist_1.png'),
						"img_hover": require("@/assets/img/solution/cardlist_1_hover.png")
					},
					{
						"name": "农业灌溉",
						"desc": "实时监测数据，智能灌溉",
						"img": require('@/assets/img/solution/cardlist_2.png'),
						"img_hover": require("@/assets/img/solution/cardlist_2_hover.png")
					},
					{
						"name": "智能家居",
						"desc": "一个应用控制部署所有家电",
						"img": require('@/assets/img/solution/cardlist_3.png'),
						"img_hover": require("@/assets/img/solution/cardlist_3_hover.png")
					},
					{
						"name": "工业采集控制",
						"desc": "远程监测实时采集数据及控制",
						"img": require('@/assets/img/solution/cardlist_4.png'),
						"img_hover": require("@/assets/img/solution/cardlist_4_hover.png")
					},
				]
			}
		},
		//计算数据
		computed: {},
		//参数数据
		props: {},
		//方法
		methods: {
			update: function(item) {
				var temp = item.img;
				item.img = item.img_hover;
				item.img_hover = temp;
			},
		},
		//组件
		components: {},
		//生命周期-创建
		created() {},
		//生命周期-准备就绪
		mounted() {},
		//监控变量
		watch: {}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import url("../../assets/common.less");
	.tab_1 {
		.el-card {
			border: 1px solid #aaa;
			text-align: center;
			color: #8391a5;
			&:hover {
				border: 1px solid @theme-color;
				color: @theme-color;
			}
			.card{
				padding: 20px;
				img {
					width: 45%;
				}
				div {
					p:nth-of-type(1) {
						font-size: 1.2em;
						line-height: 2em;
					}
					p:nth-of-type(2) {
						font-size: 0.8em;
					}
				}
			}
			
		}
	}
</style>


// WEBPACK FOOTER //
// tab_1.vue?55a4462e